// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../services/security';

const SecureLink = (props, context) => hasAccess(context.security, props.securityModule, props.securityFeature) &&
<Link
    activeClassName={props.activeClassName}
    className={props.className}
    to={props.to}
>
    <FormattedMessage id={props.label}/>
</Link>;

SecureLink.displayName = 'SecureLink';
SecureLink.propTypes = {
    activeClassName: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    securityFeature: PropTypes.string,
    securityModule: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired
};
SecureLink.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default SecureLink;



// WEBPACK FOOTER //
// ./src/shared/components/secure-link/index.js